import { Component } from '@angular/core';
import { CardDataProvider } from 'libs/core/src/lib/data-provider/card.data-provider';
import { LoaderEnum } from 'libs/core/src/lib/enum/loader.enum';
import { CardPaymentService } from 'libs/core/src/lib/service/card-payment.service';
import { LoaderService } from 'libs/core/src/lib/service/loading.service';
import { OrderStateService } from 'libs/core/src/lib/state/order.state.service';
import { CustomLoyaltyInputComponent } from '../../loyalty-input/loyalty-input.component';
import { ErrorHandlerService } from 'libs/core/src/lib/service/error-handler/error-handler.service';

@Component({ standalone: false, selector: 'app-card-input', templateUrl: './card-input.component.html' })
export class CustomCardInputComponent extends CustomLoyaltyInputComponent {
  constructor(
    protected loaderService: LoaderService,
    protected orderStateService: OrderStateService,
    protected cardPaymentService: CardPaymentService,
    protected cardDataProvider: CardDataProvider,
    private errorHandlerService: ErrorHandlerService
  ) {
    super(loaderService, orderStateService);
  }

  submit() {
    if (!this.value || !this.order) {
      return;
    }

    if (this.onSubmit.observed) {
      this.onSubmit.emit(this.value);
      this.value = '';
      return;
    }

    this.errors = [];
    this.loaderService.showLoader(LoaderEnum.MAIN);

    this.cardPaymentService.useCardByNumber(this.value).subscribe({
      next: (res) => {
        this.clear();
        this.loaderService.hideLoader(LoaderEnum.MAIN);
      },
      error: (e) => {
        const error = this.errorHandlerService.getError(e);
        if (error) {
          switch (error.code) {
            case '123':
              this.errors = ['not_found'];
              break;
            case '208':
              this.errors = ['cannot_use'];
              break;
          }
        }

        this.loaderService.hideLoader(LoaderEnum.MAIN);
      }
    });
  }
}
